export class TipoProveedorCorreo {
   public tipoProveedorCorreoId: string;
   public nombre: string;
   public activo: boolean;
   public formatoConfigFileEjemplo: string;
   public jsonFormatoConfigFileEjemplo: string;
   public valorEnum: number;
}
